export const sources={};export const img={src:"__VITE_ASSET__fQyoR3m0eA3DLqol7kyoXA__",w:640,h:640};export default{sources:sources,img:img};